module.exports = __webpack_public_path__ + "img/autosense-product-page-x.ef03e83f.png";